var utils = require( './utils' );

var same_height_cols = ( function( $ ) {

	var $groups;

	var _init = function() {
		$groups = $( '.same-height-cols' );

		_setup_groups();
	};

	var _setup_groups = function() {
		$groups.each( function( index, item ) {
			_setup_group( $( item ) );
		} )
	};

	var _setup_group = function( $group ) {
		if ( $group.data( 'height-breakpoint' ) ) {
			if ( utils.viewport_size().width >= $group.data( 'height-breakpoint' ) ) {
				_set_col_heights( $group );
			}
			$( window ).smartresize( function() {
				if ( utils.viewport_size().width >= $group.data( 'height-breakpoint' ) ) {
					_set_col_heights( $group );
				} else {
					_unset_col_heights( $group );
				}
			} );
		} else {
			_set_col_heights( $group );

			$( window ).smartresize( function() {
				_set_col_heights( $group );
			} );
		}
	};

	var _set_col_heights = function( $group ) {
		var $cols = $group.find( '.col' ),
			height = 0;

		// Give images a chance to load
		setTimeout( function (){
			$cols.each( function( index, item ) {
				if ( $( item ).outerHeight() > height ) {
					height = $( item ).outerHeight( true );
				}
			} );

			$cols.css( 'height', height );
			$group.addClass( 'heights-set' );
		},100 );
	};

	var _unset_col_heights = function( $group ) {
		var $cols = $group.find( '.col' );

		$cols.css( 'height', 'auto' );
		$group.removeClass( 'heights-set' );
	};

	if ( $( '.same-height-cols' ).length > 0 ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = same_height_cols;